<script>
    import { POSSIBLE_AUTO_BET_TIMES } from '@src/constants/index';
    import {
        isAutoplayModalOpened,
        isBetModalOpened,
        showFullScreenToolbarModal,
        isIosFullscreenModalOpened,
        skipFullScreenToolbarAgain,
        closeAllModals
    } from '@src/store/ui';

    import {
        balance,
        currency,
        selectedBetAmount,
        availableBets,
        lastSelectedAutoBetCount,
        popularBetIndex,
        selectedBetIndex
    } from '@src/store/index';

    // import SlowConnectionModal from '@src/components/ui/notifications/slow-connection.svelte';
    import IosFullscreenModal from '@src/components/ui/notifications/ios-fullscreen.svelte';

    import CrossModal from '@src/cross-reusable-components/modals/cross-modal.svelte';
    import CrossBetAmount from '@src/cross-reusable-components/modals/cross-bet-amount/cross-bet-amount.svelte';
    import CrossModalContent from '@src/cross-reusable-components/modals/cross-modal-content.svelte';
    import CrossAutoplay from '@src/cross-reusable-components/modals/cross-autoplay/cross-autoplay.svelte';
    import { EventEmitterInstance } from '@root/src/utils/event-emitter';
</script>

{#if $isAutoplayModalOpened}
    <CrossModal on:close_modal={() => closeAllModals()}>
        <CrossModalContent slot="modal-content">
            <CrossAutoplay
                autoPlayValues={POSSIBLE_AUTO_BET_TIMES}
                selectedValue={$lastSelectedAutoBetCount}
                balance={$balance}
                selectedBetAmount={$selectedBetAmount}
                currency={$currency}
                on:change-auto-play-value={e => ($lastSelectedAutoBetCount = e.detail)}
                on:start={() => {
                    EventEmitterInstance.emit('start-auto-bet');
                    closeAllModals();
                }}
            />
        </CrossModalContent>
    </CrossModal>
{/if}

{#if $isBetModalOpened}
    <CrossModal on:close_modal={() => ($isBetModalOpened = false)}>
        <CrossModalContent slot="modal-content">
            <CrossBetAmount
                betSizeOptions={$availableBets}
                selectedValue={$selectedBetAmount}
                selectedBetIndex={$selectedBetIndex}
                balance={$balance}
                currency={$currency}
                popularBetValue={$popularBetIndex}
                on:change-bet-amount={e => {
                    $selectedBetAmount = e.detail;
                    closeAllModals();
                }}
                on:change-bet-index={e => {
                    $selectedBetIndex = e.detail;
                }}
            />
        </CrossModalContent>
    </CrossModal>
{/if}

<!-- TODO: fix slow connection icon -->
<!-- {#if $isSlowConnectionDetected}
    <SlowConnectionModal on:close={() => ($isSlowConnectionDetected = false)} />
{/if} -->

{#if $isIosFullscreenModalOpened && $showFullScreenToolbarModal}
    <IosFullscreenModal
        skipFullScreenModal={$skipFullScreenToolbarAgain}
        on:close={() => ($isIosFullscreenModalOpened = false)}
        on:skip-again={event => ($skipFullScreenToolbarAgain = event.detail)}
    />
{/if}
